import React,{Component} from 'react'
import {LogoSliderComponent} from '../../pages/index'
import phone from '../../images/mini_portal/phone@2x.png'
import phone1 from '../../images/mini_portal/connect/slide-02@2x.png'
import AliceCarousel from 'react-alice-carousel';
import {Popup,PopupButton,PopupBody} from '../../components/common/Popup'
import ActiveWrapper from '../../components/common/ActiveWrapper'
import { SpanielObserver } from 'spaniel';
import group1 from '../../images/mini_portal/connect/info1.png'
import group2 from '../../images/mini_portal/connect/group-3-copy-2.png'
import group3 from '../../images/mini_portal/connect/group-3@2x.png'
import group4 from '../../images/mini_portal/connect/card-15@2x.png'
import mobilePhone1 from '../../images/mini_portal/connect/mobile-phone1.png'
import mobilePhone2 from '../../images/mini_portal/connect/mobile-phone2.png'
import mobilePhone3 from '../../images/mini_portal/connect/mobile-phone3.png'
import mobilePhone4 from '../../images/mini_portal/connect/mobile-phone5.png'
import mobilePhone5 from '../../images/mini_portal/connect/mobile-phone4.png'
import mobilePhone6 from '../../images/mini_portal/connect/mobile-phone6.png'
import axios from 'axios'
import {getDomain,postCall} from '../common/domain'


let regix = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;


const responsive = {
    0: {
        items: 1
    }
}


export class LandingPage extends Component{
    closePopup(){
        this.requestDemo.closePopup()
    }
    render(){
        const {content} = this.props
        return <div className={'products'}>
            <div className={'start-mobile'}>
                <div className={'start-content'} id={'product'}>
                    <div className={'platform'}>
                        <div className={'platform-sub'}>
                            <div className={'logo-rect'} data-aos="fade-up"></div>
                            <div className={'head-info'} data-aos="fade-up">
                                Hubbler Connect
                            </div>
                            <div className={'head-info-sub'} data-aos="fade-up">{content.head}</div>
                            <p data-aos="fade-up">{content.para}</p>
                            <Popup ref={demo=>this.requestDemo = demo}>
                                <PopupButton>
                                    <button className={'bt-blue'} data-aos="fade-up">Request Demo</button>
                                </PopupButton>
                                <PopupBody className={'request-demo-popup'}>
                                    <div className={'sub'}>
                                        <span className={'close'} onClick={()=>this.closePopup()}></span>
                                        <RequestDemo closePopup={this.closePopup.bind(this)}/>
                                    </div>
                                </PopupBody>
                            </Popup>
                        </div>
                    </div>
                </div>
            </div>
            <LogoSliderComponent/>
        </div>
    }
}

export class MobileViewComponent extends Component{
    state = {
        active:0
    }
    galleryItems(){
        const {communityWebViewData} = this.props
        return (communityWebViewData.map(item=> <div className={'mobile-scroll-animation'}>
            <div className={'mobile-view-container'}>
                <div className={'text-container one'}>
                    <div className={'first'}>{item.text[0]}</div>
                    <div className={'secand'} style={{background:!item.text[1] ? 'none' : 'auto'}}>{item.text[1]}</div>
                </div>
                <div className={'mobile-images'}>
                   <img src={item.image}/>
                </div>
                <div className={'text-container two'}>
                    <div className={'first'} style={{background:!item.text[2] ? 'none' : 'auto'}}>{item.text[2]}</div>
                    <div  className={'secand'}>{item.text[3]}</div>
                </div>
            </div>
        </div>))
    }
    galleryItemsMobiles(){
        const {communityMobileViewData} = this.props
        return (communityMobileViewData.map(item=><div className={'mobile-view-comunity'}>
           <div className={'image-container'}>
               <img src={item.image}/>
           </div>
           <p>{item.name}</p>
       </div>))
    }
    render(){
        const {head,para} = this.props.headerData
        return <div className={'mobile-view-component'}>
            <div className={'heading'} data-aos="fade-up">{head}</div>
            <p data-aos="fade-up">{para}</p>
               <div className={'for-web'} data-aos="fade-up">
                   <div className={'mobile-carousel'}>
                       <AliceCarousel autoPlay={true} autoPlayInterval={2500} duration={600} responsive={responsive} items={this.galleryItems()}/>
                   </div>
               </div>
               <div className={'for-mobile'} data-aos="fade-up">
                   <div className={'mobile-carousel'}>
                       <AliceCarousel autoPlay={true} autoPlayInterval={2500} duration={600} responsive={responsive} items={this.galleryItemsMobiles()}/>
                   </div>
               </div>
        </div>
    }
}

export class InfoItemView extends Component{
    render(){
        const {title,description,image} = this.props.itemData
        return <li data-aos="fade-up">
            <div className={'test'}>
                <div className={'head'}>{title}</div>
                <div className={'image-container'}>
                    <img src={image} />
                </div>
                <p>{description}</p>
            </div>
        </li>
    }
}

export class DashbordCarousel extends Component{
    galleryItems(){
        const {dashboardData} = this.props
        return (dashboardData.map(item=><li>
            <div className={'head'}>{item.name}</div>
            <div className={'image-container'}>
                {item.images.map(img=><div className={'img-cls'}><img src={img}/></div>)}
            </div>
            <p>{item.discription}</p>
        </li>))
    }
    galleryImageItems(images){

        return (images.map(item=><div className={'img-cls'}><img src={item}/></div>))
    }
    render(){
        const {dashboardData} = this.props;
        return <div className={'dashbord-carousel'}>
            <div className={'for-web'}>
                <AliceCarousel autoPlay={dashboardData.length === 1 ? false : true} autoPlayInterval={2500} duration={600} responsive={responsive} items={this.galleryItems()}/>
            </div>
            <div className={'for-mobile'}>
                {this.props.dashboardData.map(item=>  <div className={'mobile-carousel'}>
                    <div className={'head'}>{item.name}</div>
                    <AliceCarousel autoPlay={true} autoPlayInterval={2500} duration={600} responsive={responsive} items={this.galleryImageItems(item.images)}/>
                    <p>{item.discription}</p>
                </div>)}

               {/* <ActiveWrapper active={Boolean(secand)}>
                    <div className={'mobile-carousel'}>
                        <div className={'head'}>{secand.name}</div>
                        <AliceCarousel autoPlay={true} autoPlayInterval={2500} duration={600} responsive={responsive} items={this.galleryImageItems(secand.images)}/>
                        <p>{secand.discription}</p>
                    </div>
                </ActiveWrapper>*/}

            </div>
        </div>
    }
}

export class RequestDemo extends Component{
    state = {
        loading:false,
        name:'',
        email:'',
        mobile:'',
        showFrom:true
    }
    componentDidMount() {
        let domain = getDomain;
        this.setState({
            domain
        })
    }
    onChangeHandler(name,event){
        this.setState({
            [name]:event.target.value,
        })
    }
    submitValidate(){
        const {name,email,mobile} = this.state;
        const checkFormat = regix.test(this.state.email);
        return name !== '' && (email !== '' && checkFormat)
    }
    onSubmit(){
        const postData = {...this.state};
        delete  postData.loading
        delete  postData.domain
        this.setState({
            loading:true
        })
        postCall('/hubbler/demo/',postData).then((response)=>{
            if(response.data.success){
                this.setState({
                    loading:false,
                    name:'',
                    email:'',
                    mobile:'',
                    showFrom:false
                })
            }else {
                alert(response.data.error)
            }
        })

    }
    render(){
        const checkFormat = regix.test(this.state.email);
        if(!this.state.showFrom){
           return <div className={'request-demo form-page-container'}>
               <div className={'form-inputs-container'}>
                   <div className={'info-details'}>
                       <div className={'head'}>We have received your Demo request</div>
                       <p>Our team will get back to you soon.</p>
                   </div>
               </div>
           </div>
        }
        return <div className={'request-demo form-page-container'}>
                        <div className={'head'}>Request Demo</div>
                        <div className={'form-view form-inputs-container'}>
                            <div className={'inputs-list'}>

                                <div className={'inputs'}>
                                    <label>Name <b>*</b></label>
                                    <input type="text" placeholder={'e.g., John Smith'} onChange={this.onChangeHandler.bind(this,'name')} disabled={this.state.loading ? true :false} value={this.state.name} autoComplete={'off'}/>
                                </div>

                                <div className={'inputs'}>
                                    <label>Company Email <b>*</b></label>
                                    <input type="text" placeholder={'name@company.com'}  onChange={this.onChangeHandler.bind(this,'email')} disabled={this.state.loading ? true :false}  value={this.state.email} autoComplete={'off'}/>
                                    {(checkFormat || this.state.email === '') ? '' : <span className={'text-danger'}>email format is not correct</span>}
                                </div>

                                <div className={'inputs'}>
                                    <label>Phone No</label>
                                    <input type="number" placeholder={'+91 9988 766 554'} onChange={this.onChangeHandler.bind(this,'mobile')} disabled={this.state.loading ? true :false} value={this.state.mobile} autoComplete={'off'}/>
                                </div>
                                <div className={'footer'}>
                                    <button href="" tabIndex={this.submitValidate() ? 0 : -1} className={this.submitValidate() ? 'submit bt-blue' : 'submit bt-blue disable'} id={this.state.loading ? 'bt-loading' : ''} onClick={this.onSubmit.bind(this)}>Request Demo</button>
                                </div>
                            </div>
                        </div>
            </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/mini_portal_components/mini-portal_components.js